import { PriceQuoteAction } from 'routes/essential-workspace/components/quote-panel/quote/quote-actions/price';

export function PricedQuoteActions() {
  return (
    <div className="flex-x gap-2 w-100">
      <PriceQuoteAction
        className="btn-discreet-secondary w-100"
        purpose="primary"
        labelTranslationKey="sidePanel.actions.reprice"
      />
    </div>
  );
}
